
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '关区名称',
value: this.$route.params.Item.PC_Name_All
}, {
label: '关区简称',
value: this.$route.params.Item.PC_Name_Abbr
}]
}
}



// WEBPACK FOOTER //
// ./src/components/CustomsDetail.vue